import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const reduxModuleLoaded = createAction(`${reduxKey}.EARNINGS_REDUX_READY`, ()=>({}));
export const initializeEarningsDisplay = createAction(`${reduxKey}.INITIALIZE_EARNINGS_DISPLAY`, (displayId, productType, price)=>({
        displayId,
        productType,
        price
    }));
export const destroyEarningsDisplay = createAction(`${reduxKey}.DESTROY_EARNINGS_DISPLAY`, (displayId)=>({
        displayId
    }));
export const updatePrice = createAction(`${reduxKey}.UPDATE_PRICE`, (displayId, price)=>({
        displayId,
        price
    }));
export const updateEstimatedEarnings = createAction(`${reduxKey}.UPDATE_EARNINGS`, (displayId, data)=>({
        displayId,
        data
    }));
export const fetchFailed = createAction(`${reduxKey}.FETCH_FAILED`, (displayId, errorMessage)=>({
        displayId,
        errorMessage
    }));
